<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>建造价格配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload0"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res, 'config')}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:buildCfg:importConfig']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:buildCfg:exportConfig']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData('config')"
              >导出</el-button>
            </el-col>
            <el-col :span="1.5"> <clear-cache-apply /> <sync-data /></el-col>
            <!--            <el-col :span="1.5">-->
            <!--              <el-button-->
            <!--                v-permisaction="['config:buildCfg:exportReward']"-->
            <!--                type="primary"-->
            <!--                icon="el-icon-download"-->
            <!--                size="mini"-->
            <!--                @click="exportData('reward')"-->
            <!--              >导出通关奖励</el-button>-->
            <!--            </el-col>-->
            <el-col :span="1.5"><el-button v-permisaction="['config:buildCfg:add']" type="success" size="mini" @click="onSubmit">保存</el-button></el-col>
          </el-row>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="start" label="等级范围">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="奖励" width="450px">
            <template slot-scope="scope">
              <Reward :value="scope.row.reward" />
            </template>
          </el-table-column>
          <el-table-column label="建造物品">
            <div>建造价格</div>
            <div>皮肤ID</div>
            <div>获得车辆</div>
          </el-table-column>
          <el-table-column v-for="(v, index) in numbers" :key="index" :label="v+1">
            <template slot-scope="scope">
              <div>{{ scope.row.config.length > v ? scope.row.config[v].coins.join(',') : '-' }}</div>
              <div>{{ scope.row.config.length > v ?scope.row.config[v].skin.join(',') :'-' }}</div>
              <div>{{ scope.row.config.length > v ?scope.row.config[v].car :'-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px">
            <template slot-scope="scope">
              <el-form :inline="true">
                <el-form-item>
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="configVisibleArr[scope.$index].visible = true"> 关卡配置</el-button>
                  <el-drawer :before-close="(d)=>{return handleClose(d, scope.$index)}" title="关卡配置" size="710px" :visible="configVisibleArr[scope.$index].visible">
                    <el-form>
                      <el-row v-for="(e,i) in scope.row.config" :key="i">
                        <el-form-item style="margin-top: 10px;" label="建筑ID">
                          <el-input v-model.number="e.id" readonly style="width: 100px" placeholder="关卡" autocomplete="off" />
                        </el-form-item>

                        <el-form-item label="建筑价格皮肤配置" style="margin-top: 10px;">
                          <el-button type="primary" size="mini" icon="el-icon-edit" @click="configPrizeVisibleArr[scope.$index][i].visible = true" />
                          <el-dialog :before-close="(d)=>{return handlePrizeClose(d, scope.$index, i)}" title="建筑价格皮肤配置" width="520px" :visible="configPrizeVisibleArr[scope.$index][i].visible" append-to-body>
                            <el-form :inline="true">
                              <el-row v-for="(s, skIndex) in e.skin" :key="skIndex">
                                <el-form-item style="margin-top: 10px;" label="皮肤ID">
                                  <el-input v-model="e.skin[skIndex]" style="width: 100px" autocomplete="off" />
                                </el-form-item>
                                <el-form-item style="margin-top: 10px;" label="价格">
                                  <el-input v-model="e.coins[skIndex]" style="width: 100px" autocomplete="off" />
                                </el-form-item>
                                <el-form-item>
                                  <el-button v-if="e.skin.length >1" style="margin-top: 10px;" type="danger" @click="removePrizeEvent(scope.$index, i, skIndex)">删除</el-button>
                                </el-form-item>
                              </el-row>
                            </el-form>
                            <el-form-item style="margin-top: 10px">
                              <el-button v-if="scope.row.config.length < 31" type="primary" @click="addPrizeEvent(scope.$index, i)">+</el-button>
                            </el-form-item>
                            <div slot="footer" class="dialog-footer">
                              <el-button @click="configPrizeVisibleArr[scope.$index][i].visible = false">取 消</el-button>
                              <el-button type="primary" @click="configPrizeVisibleArr[scope.$index][i].visible = false">确 定</el-button>
                            </div>
                          </el-dialog>
                        </el-form-item>

                        <el-form-item style="margin-top: 10px;" label="获得车辆">
                          <el-input v-model.number="e.car" style="width: 100px" autocomplete="off" />
                        </el-form-item>

                        <el-form-item>
                          <el-button v-if="scope.row.config.length > 20" style="margin-top: 10px;" type="danger" @click="removeEvent(scope.$index, i, 'config')">删除</el-button>
                        </el-form-item>
                      </el-row>
                      <el-form-item style="margin-top: 10px">
                        <el-button v-if="scope.row.config.length < 31" type="primary" @click="addEvent(scope.$index,'config')">+</el-button>
                      </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="configVisibleArr[scope.$index].visible = false">取 消</el-button>
                      <el-button type="primary" @click="configClick(scope.$index)">确 定</el-button>
                    </div>
                  </el-drawer>
                </el-form-item>

                <!--                <el-form-item>-->
                <!--                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="rewardVisibleArr[scope.$index].visible = true">奖励配置</el-button>-->
                <!--                  <el-drawer title="奖励配置" :before-close="(d)=>{return handlePrize1Close(d, scope.$index, i)}" size="950px" :visible="rewardVisibleArr[scope.$index].visible">-->
                <!--                    <el-form style="max-height: 700px;overflow-x: auto">-->
                <!--                      <el-row v-for="(e,i) in scope.row.reward" :key="i">-->
                <!--                        <el-form-item style="margin-top: 10px;" label="道具ID">-->
                <!--                          <el-select v-model.number="e.propsId" style="width: 130px;" placeholder="请选择" @change="v=>propChange(v,scope.$index, i)">-->
                <!--                            <el-option-->
                <!--                              v-for="(item, index) in rewardType"-->
                <!--                              :key="index"-->
                <!--                              :label="item.label"-->
                <!--                              :value="item.value"-->
                <!--                            />-->
                <!--                          </el-select>-->
                <!--                        </el-form-item>-->

                <!--                        <el-form-item v-if="skinId.includes(e.propsId)" style="margin-top: 10px;" label="皮肤">-->
                <!--                          <el-select v-if="e.propsId === 62" v-model.number="e.skin" placeholder="请选择" style="width: 100px">-->
                <!--                            <el-option-->
                <!--                              v-for="item in chessId"-->
                <!--                              :key="item.value"-->
                <!--                              :label="item.label"-->
                <!--                              :value="item.value"-->
                <!--                            />-->
                <!--                          </el-select>-->

                <!--                          <el-select v-if="e.propsId === 19" v-model.number="e.skin" placeholder="请选择" style="width: 100px">-->
                <!--                            <el-option-->
                <!--                              v-for="item in areaId"-->
                <!--                              :key="item.value"-->
                <!--                              :label="item.label"-->
                <!--                              :value="item.value"-->
                <!--                            />-->
                <!--                          </el-select>-->
                <!--                        </el-form-item>-->

                <!--                        <el-form-item style="margin-top: 10px;" label="道具数量">-->
                <!--                          <el-input v-model.number="e.num" :readonly="skinId.includes(e.propsId)" style="width: 70px" :prop="'formData.'+scope.$index+'.config' +i +'.num'" autocomplete="off" />-->
                <!--                        </el-form-item>-->

                <!--                        <el-form-item style="margin-top: 10px;" label="金币取值">-->
                <!--                          <el-select v-model.number="e.rtype" :disabled="e.propsId !== 14" placeholder="请选择" style="width: 120px" :prop="'formData.'+scope.$index+'.config' +i +'.rtype'">-->
                <!--                            <el-option-->
                <!--                              v-for="item in selectType"-->
                <!--                              :key="item.id"-->
                <!--                              :label="item.title"-->
                <!--                              :value="item.id"-->
                <!--                            />-->
                <!--                          </el-select>-->
                <!--                        </el-form-item>-->
                <!--                        &lt;!&ndash;                    <el-form-item style="margin-top: 10px;" label="皮肤ID">&ndash;&gt;-->
                <!--                        &lt;!&ndash;                      <el-input v-model="e.skin" style="width: 100px" :prop="'formData.'+index+'.config' +i +'.skin'" autocomplete="off" />&ndash;&gt;-->
                <!--                        &lt;!&ndash;                    </el-form-item>&ndash;&gt;-->
                <!--                        <el-form-item>-->
                <!--                          <el-button v-if="scope.row.reward.length > 1" style="margin-top: 10px;" type="danger" @click="removeEvent(scope.$index, i, 'reward')">删除</el-button>-->
                <!--                        </el-form-item>-->
                <!--                      </el-row>-->
                <!--                      <el-form-item style="margin-top: 10px">-->
                <!--                        <el-button v-if="scope.row.reward.length < 31" type="primary" @click="addEvent(scope.$index, 'reward')">+</el-button>-->
                <!--                      </el-form-item>-->
                <!--                    </el-form>-->
                <!--                    <div slot="footer" class="dialog-footer">-->
                <!--                      <el-button @click="rewardVisibleArr[scope.$index].visible = false">取 消</el-button>-->
                <!--                      <el-button type="primary" @click="rewardVisibleArr[scope.$index].visible = false">确 定</el-button>-->
                <!--                    </div>-->
                <!--                  </el-drawer>-->
                <!--                </el-form-item>-->
              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { updateBuildCfgList, getBuildCfgList, exportBuildCfg, importBuildCfg } from '@/api/config/build-cfg'
import { getToken } from '@/utils/auth'
import { getRewardType } from '@/api/config/slot'
import { getRewardListForPropsId } from '@/utils'
import Reward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'BuildConfig',
  components: { SyncData, ClearCacheApply, Reward },
  data() {
    return {
      numbers: [],
      loading: false,
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      configPrizeVisibleArr: {},
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      rewardType: [],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      cardsType: [
        {
          'id': 1,
          'title': '是'
        },
        {
          'id': 0,
          'title': '否'
        }
      ],
      formData: [
        {
          'id': 0,
          'config': [{
            'id': 1,
            'skin': [],
            'coins': [],
            'car': 0
          }],
          'reward': [{
            'propsId': 14,
            'num': 0,
            'rtype': 0,
            'skin': ''
          }]
        }
      ],
      formInline: [],
      chessId: [],
      areaId: []
    }
  },
  created() {
    this.getTables()
    this.initNum()
  },
  methods: {
    handleClose(done, index) {
      this.configVisibleArr[index].visible = false
      done()
    },
    handlePrizeClose(done, index, i) {
      this.configPrizeVisibleArr[index][i].visible = false
      done()
    },
    handlePrize1Close(done, index, i) {
      this.rewardVisibleArr[index].visible = false
      done()
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        const level = _data.id
        for (const cIndex in _data) {
          if (cIndex === 'config') {
            const _config = _data[cIndex]
            console.log(_config)
            for (const _ci in _config) {
              const skin = _config[_ci].skin
              const id = _config[_ci].id
              for (const skinx in skin) {
                if (skin[skinx] === '') {
                  console.log('data', _data[cIndex])
                  this.msgError('等级：' + level + ' 建筑ID：' + id + ' 皮肤ID不能为空')
                  return
                }
              }
            }
          }
        }
      }

      const data = JSON.stringify(this.formData)
      console.log(data)
      updateBuildCfgList({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.formData = []
      this.getRewardTypeData()
      getBuildCfgList(this.queryParams).then(res => {
        res.data.list.forEach((item, index) => {
          this.configVisibleArr.push({
            visible: false
          })
          this.$set(this.configPrizeVisibleArr, index, [])
          this.rewardVisibleArr.push({
            visible: false
          })
          item.config.forEach((r) => {
            this.configPrizeVisibleArr[index].push({
              visible: false
            })
          })
        })
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      const id = this.formData.length
      console.log('add index', id)
      this.$set(this.configPrizeVisibleArr, id, [])
      console.log(this.configPrizeVisibleArr)
      const _config = []
      for (let i = 1; i <= 20; i++) {
        _config.push({
          'id': i,
          'skin': [],
          'coins': [],
          'car': 0
        })
        this.configPrizeVisibleArr[id].push({ visible: false })
      }
      this.formData.push({
        id: id + 1,
        config: _config,
        reward: [{
          'propsId': 14,
          'num': 0,
          'rtype': 1,
          'skin': ''
        }]
      })
      this.configVisibleArr.push({ visible: false })
      this.rewardVisibleArr.push({ visible: false })
    },
    exportData(name) {
      console.log(name)
      exportBuildCfg({ name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response, name) {
      this.loading = true
      if (name === 'config') {
        this.$refs['upload0'].clearFiles()
      } else {
        this.$refs['upload1'].clearFiles()
      }
      importBuildCfg({ data: response.data.path, name: name }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importMoneyUploadSuccess(response, file, fileList) {
      // importSlotWeightCfg({ path: response.data.path, ImportType: 2 }).then(res => {
      //   // eslint-disable-next-line eqeqeq
      //   if (res.code === 200) {
      //     this.msgSuccess(res.msg)
      //     this.getTables()
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    },
    addEvent(index, name) {
      if (name === 'config') {
        const id = this.formData[index][name].length
        this.formData[index][name].push({
          'id': id + 1,
          'skin': [],
          'coins': [],
          'car': 0
        })
        this.configPrizeVisibleArr[index].push({
          visible: false
        })
      } else {
        this.formData[index][name].push({
          'propsId': 14,
          'num': 0,
          'rtype': 1,
          'skin': 0
        })
      }
    },
    removeEvent(index, key, name) {
      this.formData[index][name] = this.formData[index][name].filter((item, k) => {
        return key !== k
      })
    },
    addPrizeEvent(index, key) {
      this.formData[index]['config'][key].skin.push('')
      this.formData[index]['config'][key].coins.push(0)
    },
    removePrizeEvent(index, key, skIndex) {
      this.formData[index]['config'][key].skin = this.formData[index]['config'][key].skin.filter((res, i) => {
        return i !== skIndex
      })

      this.formData[index]['config'][key].coins = this.formData[index]['config'][key].coins.filter((res, i) => {
        return i !== skIndex
      })
    },
    configClick(index) {
      this.configVisibleArr[index].visible = false
      this.onSubmit()
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    initNum() {
      for (let i = 0; i < 25; i++) {
        this.numbers.push(i)
      }
    }, getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    }
  }
}
</script>

<style scoped>
</style>
